import React from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

export default function Badge({
  children,
  variant = "default",
  size = "sm",
  className = "",
  ...props
}) {
  const variantStyles = {
    default:
      "bg-gray-100 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-700/60",
    secondary:
      "bg-secondary-ultra-light dark:bg-secondary/20 text-secondary dark:text-secondary-light border border-secondary/30",
    primary:
      "bg-primary/15 text-primary border border-primary/30",
    outline:
      "bg-transparent text-gray-600 dark:text-gray-400 border border-gray-300 dark:border-gray-700",
    muted:
      "bg-gray-50 dark:bg-gray-800/50 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-gray-700/50",
    dark:
      "bg-gray-800/90 text-gray-200 border border-gray-700/60 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700",
    success:
      "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20",
    warning:
      "bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20",
  };

  const sizeStyles = {
    xs: "px-2 py-0.5 text-[11px]",
    sm: "px-2.5 py-0.5 text-xs",
    md: "px-3 py-1 text-xs",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 font-medium rounded-full transition-colors whitespace-nowrap",
        variantStyles[variant] || variantStyles.default,
        sizeStyles[size] || sizeStyles.sm,
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
